/* eslint-disable */

import { PACKAGE_DATA_FETCH_ERR, PACKAGE_DATA_FETCH_SUCCESS } from "./actions";


const initialState = {
  packages: [],
  error: null,
};

const packageReducer = (state = initialState, action) => {
  const { type, data, err } = action;

  switch (type) {
    case PACKAGE_DATA_FETCH_SUCCESS:
      return {
        ...state,
        packages: data,
        error: null,
      };
    case PACKAGE_DATA_FETCH_ERR:
      return {
        ...state,
        error: err,
      };
    default:
      return state;
  }
};

export { packageReducer };

